import { Injectable } from '@angular/core';
import {UtilService} from "../util/util.service";
import {ViewDefinition} from "../../models/view/view-definition";
import {ViewModel} from "../../models/view/view-model";
import {TableDefinition} from "../../models/table/table-definition";
import {TableModel} from "../../models/table/table-model";
import {DetailContentModel} from "../../models/content/detail-content-model";
import {ListContentModel} from "../../models/content/list-content-model";

@Injectable({
  providedIn: 'root'
})
export class ContentDataService {

  constructor() {
    (window as any).NG_SHARED_CONTENT_DATA_SERVICE = this;
  }

  static viewModelHasErrors(data: any): boolean {
    UtilService.notImplemented("ContentDataService", "viewModelHasErrors");
    return false;
  }

  static getFilteredContentData(data: any, overrideSendToServer: boolean, includeExtraJournalEntries: boolean): any {

    // If in a list context the data is the raw data and has not been mapped by KO, if in a detail context it is the mapped record.

    const mappingSettings =
      {
        'ignore' : ["_tableClass"],
        'include' : ["_journalEntries"]
      };

    // Note that the toJS call will not leave _journalEntries in data. as it was not originally mapped, so we
    // have to put it explicitly in the options.
    data = Array.isArray(data) ? data : (window as any).KO_MAPPING.toJS(data, mappingSettings);

    let result = {};

    // If data is not an array it is the data representing a table record
    Object.getOwnPropertyNames(data).forEach((fieldName) => {
      const fieldValue = data[fieldName];

      if (fieldValue !== null && fieldValue.hasOwnProperty('value')) {
        if (!overrideSendToServer && fieldValue.hasOwnProperty('sendToServer') && !fieldValue['sendToServer']) {
          return; // effectively a continue if done inside a forEach
        }

        if (UtilService.isPlainObject(fieldValue.value)) {
          if (fieldValue.fieldType === "reference") {
            result[fieldName] = fieldValue.value.id;
          } else {
            result[fieldName] = fieldValue.value;
          }
        } else if (Array.isArray(fieldValue.value)) {
          result[fieldName] = fieldValue.value.map((v) => {
            if (v !== null) {
              return v.hasOwnProperty("id") ? v.id : v;
            } else {
              return null;
            }
          }).filter(x => x !== null);
        } else {
          result[fieldName] = fieldValue.value === undefined ? null : fieldValue.value;
        }

      } else if (fieldName.startsWith("_")) {
        return;
      } else {
        result[fieldName] = fieldValue;
      }
    });

    if (includeExtraJournalEntries && data._journalEntries) {
      const journalEntries = {};
      Object.getOwnPropertyNames(data._journalEntries).forEach((fieldName) => {
        const fieldValue = data._journalEntries[fieldName];
        journalEntries[fieldName] = fieldValue.map((j) => {
          delete j._id;
          return j;
        });
      });
      data._journalEntries = journalEntries;
    }

    return result;
  }

  createListContentModel(viewDefinitionOrModel: ViewDefinition | ViewModel,
                                  tableDefinitionOrModel: TableDefinition | TableModel,
                                  data?: any): ListContentModel {
    return new ListContentModel(viewDefinitionOrModel, tableDefinitionOrModel, data);
  }

  createDetailContentModel(viewDefinitionOrModel: ViewDefinition | ViewModel,
                                  tableDefinitionOrModel: TableDefinition | TableModel,
                                  data?: any): DetailContentModel {
    return new DetailContentModel(viewDefinitionOrModel, tableDefinitionOrModel, data);
  }
}
